// extracted by mini-css-extract-plugin
export default {"root":"ButtonGroup_root__spGu-","button":"ButtonGroup_button__Ng-53","buttonActive":"ButtonGroup_buttonActive__uc0ph"};